import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { HttpModule } from '@angular/http'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { ChartsModule } from 'ng2-charts/ng2-charts'
import { MyDatePickerModule } from 'mydatepicker'
import { MyDateRangePickerModule } from 'mydaterangepicker'

import { RequestOptions } from '@angular/http'
import { RequestOptionsExtension } from './request-options.extension'

import { SearchBarComponent } from './forms/search-bar/search-bar.com'
import { SingleImageUploadComponent } from './single-image-upload/single-image-upload.com'
import { MultiFileUploadComponent } from './multi-file-upload/multi-file-upload.com'

// holders
import { ConfirmationBoxComponent } from './confirmation-box/confirmation-box.com'
import { LocalLoaderComponent } from './holders/local-loader/local-loader.com'

import { SearchBoxComponent } from './forms/search-box/search-box.com'
import { DateRangeComponent } from './date-range/date-range.com'
import { PaginationComponent } from './pagination/pagination.com'

import { ItemSnippetComponent } from './holders/item-snippet/item-snippet.com'
import { SkuSnippetComponent } from './holders/sku-snippet/sku-snippet.com'

import { ItemImportFormComponent } from './forms/item-import-form/item-import-form.com'
import { OrderFormComponent } from './forms/order-form/order-form.com'
import { WriteOffFormComponent } from './forms/write-off-form/write-off-form.com'
import { DatePickerComponent } from './form-snippets/date-picker/date-picker.com'
import { SingleImageFormControlComponent } from './form-controls/single-image/single-image.form-control'

import { BackService } from '../../services/back.service'
import { StorageService } from '../../services/storage.service'
import { AsyncValidator } from '../../validators/async.validator'
import { SyncValidator } from '../../validators/sync.validator'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HttpModule,
    ReactiveFormsModule,
    MyDatePickerModule,
    MyDateRangePickerModule
  ],
  providers: [
    AsyncValidator,
    SyncValidator,
    BackService,
    StorageService,
    { provide: RequestOptions, useClass: RequestOptionsExtension }
  ],
  declarations: [
    SearchBarComponent,
    SingleImageUploadComponent,
    MultiFileUploadComponent,
    ConfirmationBoxComponent,
    SearchBoxComponent,
    DateRangeComponent,
    ItemSnippetComponent,
    SkuSnippetComponent,
    ItemImportFormComponent,
    OrderFormComponent,
    WriteOffFormComponent,
    DatePickerComponent,
    PaginationComponent,
    LocalLoaderComponent,
    SingleImageFormControlComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    MyDatePickerModule,
    MyDateRangePickerModule,
    HttpModule,
    SearchBarComponent,
    SingleImageUploadComponent,
    MultiFileUploadComponent,
    ConfirmationBoxComponent,
    SearchBoxComponent,
    DateRangeComponent,
    ItemSnippetComponent,
    SkuSnippetComponent,
    ItemImportFormComponent,
    OrderFormComponent,
    WriteOffFormComponent,
    DatePickerComponent,
    PaginationComponent,
    LocalLoaderComponent,
    SingleImageFormControlComponent
  ]
})

export class SharedModule {}



// WEBPACK FOOTER //
// ./src/app/modules/shared/shared.module.ts